import React from "react"
import styled from "styled-components"
const Form = ({ text, buttonText, lang }) => {
  const words = {
    ar: {
      emailText: "الإيميل",
      name: "الإسم",
      phone: "الهاتف",
      country: "البلد",
    },
    en: {
      emailText: "Email",
      name: "Name",
      phone: "Phone",
      country: "Country",
    },
    tr: {
      emailText: "email",
      name: "isim",
      phone: "Telefon",
      country: "Ülke",
    },
  }
  const { emailText, name, phone, country } = words[lang]
  return (
    <Wraper>
      <form
        action="https://formspree.io/xrgozllo"
        method="POST"
        className={` ${lang !== "ar" && "langFormStyle"}`}
      >
        <div className="inputsContainer">
          <div>
            <input type="email" name="email" placeholder={emailText} />
          </div>
          <div>
            <input type="text" neme="name" placeholder={name} />
          </div>
          <div>
            <input type="text" name="phoneNumber" placeholder={phone} />
          </div>
          <div>
            <input type="text" name="country" placeholder={country} />
          </div>
        </div>
        <div>
          <textarea placeholder={text} name="messageBody" />
        </div>
        <div className="button">
          <button>{buttonText}</button>
        </div>
      </form>
    </Wraper>
  )
}

export default Form
const Wraper = styled.section`
  .langFormStyle {
    input,
    textarea,
    .button {
      text-align: start;
    }
  }
  .inputsContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
  input {
    width: 100% !important;
  }
  input,
  textarea,
  button {
    background-color: #e9eeed;
    font-family: "Cairo", sans-serif;
    text-align: end;
    border: 0;
    font-size: 1.2rem;
    padding: 15px 30px;
    border-radius: 10px;
    &:focus {
      outline: none !important;
      box-shadow: 0 0 10px ${props => props.theme.dg};
    }
  }
  textarea {
    width: 100%;
    margin-top: 20px;
    height: 160px;
  }
  button {
    text-align: end;
    font-weight: bold;
    color: white;
    background: ${props => props.theme.dg};
    padding: 10px 15px;
    border-radius: 15px;
  }
  .button {
    text-align: end;
  }
  @media (max-width: 600px) {
    input,
    textarea,
    button {
      font-size: 0.8rem;
    }
  }
`
